import tw, { styled } from "twin.macro"

export const Embed = styled.div`
  ${({layout}) => layout === 'desktop' ? tw`hidden lg:block` : tw`block lg:hidden`}
`;
